<template>
  <div>
    <draggable
      v-model="form.rows"
      :group="{ name: itemGroup }"
      @change="rowChanged"
      ghost-class="ghost-row"
      handle=".row-action-handle"
      v-bind="dragOptions"
    >
      <!-- Element Designer Row -->
      <div
        class="element-designer-row"
        v-for="(row, index) in form.rows"
        :key="row.index"
      >
        <div
          class="element-designer-hint"
          v-if="!row || !row.items || !row.items.length"
        >
          <font-awesome-icon :icon="['far', 'hand-point-right']" class="element-designer-hint-icon"/>
          Drop <b class="fts-font-medium">Information</b> or <b class="fts-font-medium">Element</b> here
        </div>
        <!-- Element Designer Row Wrapper -->
        <div class="element-designer-row-wrapper">
          <!-- Element Designer Items -->
          <draggable
            class="element-designer-items"
            :list="row.items"
            :group="{ name: itemGroup }"
            handle=".handle"
            ghost-class="ghost-row"
            @change="changed"
            v-bind="dragOptions"
          >
            <!-- Element Designer Item -->
            <div
              class="element-designer-item"
              v-for="item in row.items"
              :key="item.title"
              :class="{ 'fw-element-item': getElementType(item.type) }"
            >
              <div
                class="element-designer-item-wrapper"
                :class="{
                  'element-description':
                    item.input == 'description' ||
                    item.input == 'empty' ||
                    item.input == 'image',
                }"
              >
                <font-awesome-icon
                  :icon="['fas', 'grip-vertical']"
                  fixed-width
                  class="element-designer-item-handle handle"
                />
                <fts-design-element
                  :item="item"
                  :activityId="activityId"
                  :form="activityDesign"
                  :document="document"
                  @added="elementAdded"
                  @remove="elementRemoved(row, $event)"
                  v-if="item.input === 'section'"
                />
                <fts-design-element
                  :activityId="activityId"
                  :form="activityDesign"
                  :document="document"
                  :item="item"
                  @remove="elementRemoved(row, $event)"
                  v-else
                />
              </div>
            </div>
          </draggable>
        </div>
        <!-- Element Designer Row Add -->
        <div
          class="element-designer-row-add"
          :class="{ 'drag-over': index == overRow }"
        >
          <span>{{ overRow }}&nbsp;+ drop information or element to insert row</span>
        </div>
      </div>

      <!-- Element Designer Row Add -->
      <div slot="header" class="element-designer-row-add">
        <span>+ drop information or element to insert row</span>
        <div
          class="element-designer-hint element-designer-hint-icon"
          v-if="!form || !form.rows || !form.rows.length"
        >
          <font-awesome-icon :icon="['far', 'hand-point-right']" class="element-designer-hint-icon"/>
          Drop <b class="fts-font-medium">Information</b> or <b class="fts-font-medium">Element</b> here
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import commons from "../commons/commons";
// import FTSDesignElement from "../elements/FTSDesignElement";

export default {
  components: {
    draggable,
    // "fts-design-element": FTSDesignElement
  },
  props: [
    "form",
    "itemGroup",
    "informationSource",
    "document",
    "activityId",
    "activityDesign",
  ],
  data() {
    return {
      dragOptions: commons.dragOptions,
      overRow: null,
    };
  },
  methods: {
    dragenter(index) {
      console.log("drag enter:" + index);
    },
    getElementType(type) {
      if (type === 14 || type === 15) return true;
      else return false;
    },
    elementRemoved(row, item) {
      let ind = row.items.indexOf(item);
      row.items.splice(ind, 1);
      this.clearUnusedRows();
    },
    remove(row) {
      let ind = this.form.rows.indexOf(row);
      this.form.rows.splice(ind, 1);
      this.clearUnusedRows();
    },
    changed(e) {
      if (e.added && e.added.element) {
        if (this.informationSource && e.added.element.id) {
          commons.expandWorkDesignInternal(
            this.informationSource,
            e.added.element
          );
        }

        if (e.added.element.item) {
          e.added.element.item.id = commons.newUUID();
        }
        this.$emit("added", e.added.element);
        this.clearUnusedRows();
      }
    },
    clearUnusedRows() {
      var rows = this.form.rows.slice();
      rows.forEach((row) => {
        if (!row.items || row.items.length == 0) {
          let ind = this.form.rows.indexOf(row);
          this.form.rows.splice(ind, 1);
        }
      });
    },
    rowMoved(e) {
      // console.log(elementAdded);
    },
    elementAdded(elementAdded) {
      if (elementAdded.item) {
        elementAdded.item.id = commons.newUUID();
      }
      this.$emit("added", elementAdded);
    },
    rowChanged(e) {
      if (e.added && e.added.element) {
        let ind = this.form.rows.indexOf(e.added.element);
        this.form.rows.splice(ind, 1, {
          index: commons.newUUID(),
          items: [e.added.element],
        });

        if (this.informationSource && e.added.element.id) {
          commons.expandWorkDesignInternal(
            this.informationSource,
            e.added.element
          );
        }

        this.clearUnusedRows();

        if (e.added.element.item) {
          e.added.element.item.id = commons.newUUID();
        }
        this.$emit("added", e.added.element);
      }

      //this.clearUnusedRows();
    },
  },
  watch: {
    form: function (val) {
      if (!val) {
        this.form = { rows: [{ items: [] }] };
      } else if (!val.rows) {
        this.form.rows = [{ items: [] }];
      }
    },
  },
};
</script>

<style lang="scss">
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
@import "./src/assets/scss/vars.scss";

.element-designer-item:hover {
  flex: 1 1 100%;
}

@mixin media-query {
  @media (max-width: 767.98px) {
    flex: 0 0 100%;
  }
  @media (min-width: 768px) and (max-width: 991.98px) {
    flex: 1 1 50%;
  }
  @media (min-width: 992px) and (max-width: 1199.98px) {
    flex: 1 1 33.333333%;
  }
  @media (min-width: 1200px) {
    flex: 1 1 33.333333%;
  }
}

// Ghost Row
.ghost-row {
  // Draggable Tool Item
  &.draggable-tool-item {
    position: relative;
    .insert-text {
      position: absolute;
      top: -0.375rem;
      left: 0;
      display: inline-flex;
      box-shadow: var(--fts-elevation-3);
      z-index: 1;
    }
    @include media-query;
    margin: 3px 0;
    .fts-design-tool-container {
      flex: 1;
      height: 100%;
      margin: 0 3px;
      .fts-design-tool-item {
        flex: 1;
        height: 100%;
        margin: 0;
        padding-left: 1.575rem;
        .element-table-container {
          display: none;
        }
        .element-remove {
          display: none;
        }
      }
    }
  }
  // Element Designer Item
  &.element-designer-item {
    margin: 3px 0;
    max-width: 100%;
    .element-designer-item-wrapper {
      display: flex;
      margin: 0 3px;
      height: 100%;
      border: 1px solid $grayLightenColor;
      background: #fff;
      .handle {
        margin: 0.675rem 0.175rem 0 0.375rem;
        font-size: 0.75rem;
        color: #9e9e9e;
        cursor: grab;
      }
    }
  }
  // Design Element Table Column
  &.design-element-table-column {
    @include media-query;
    display: flex;
    margin: 3px 0;
    padding: 0 0.375rem;
    border: 1px solid $borderColor;
    > div {
      margin: 0 3px;
    }
  }
}
</style>